module.exports = __webpack_public_path__ + "img/Password_management.3969143f.svg";